module.exports = __webpack_public_path__ + "static/media/concernIcon.a81debcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/concernIcon.png
// module id = 905
// module chunks = 0